export const ADD_TEAM = "ADD_TEAM"
export const UPDATE_TEAM = "UPDATE_TEAM"
export const SET_LOADING = "SET_LOADING"
export const SET_SINGLE_TEAM = "SET_SINGLE_TEAM"
export const ADD_USER = "ADD_USER"
export const SET_USER = "SET_USER"
export const LOGOUT_USER = "LOGOUT_USER"
export const UPLOAD_PHOTOS = "UPLOAD_PHOTOS"
export const ADD_ASSIGNMENT = "ADD_ASSIGNMENT"
export const YOUR_CREATIONS = "YOUR_CREATIONS"
